/* The overview now leads with the shared command band (BoardHeader), which carries
   its own full-bleed negative margins, so this container just stacks the header and
   the columns — matching the board view's own wrapper. */
.overview {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-3);
}

.columns {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: var(--spacing-4);
	align-items: start;
}

/* Phones: one column per row rather than three cramped lanes. */
@media (width <= 640px) {
	.columns {
		grid-template-columns: 1fr;
	}
}
